// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder {
  background-color: #ff09; /* semi-transparent yellow */
}
`, "",{"version":3,"sources":["webpack://./src/adjustments.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,4BAA4B;AACvD","sourcesContent":[".placeholder {\n  background-color: #ff09; /* semi-transparent yellow */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
